import smoothscroll from "smoothscroll-polyfill";

export default () => {
    function supportsSmoothScrolling() {
        const body = document.body;
        const scrollSave = body.style.scrollBehavior;
        body.style.scrollBehavior = "smooth";
        const hasSmooth = getComputedStyle(body).scrollBehavior === "smooth";
        body.style.scrollBehavior = scrollSave;
        return hasSmooth;
    }
    if (!supportsSmoothScrolling()) {
        smoothscroll.polyfill();
    }
};
